import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (Id) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    url: '',
    name: 'DELETE_BLOCKED_REASON',
    method: 'DELETE',
  });

  useEffect(() => {
    if (Id) {
      exec(`/api/blocked_reason/${Id}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  return [isRequestSuccessed, rst];
});
